import React from 'react'
import { Header } from 'semantic-ui-react'
import styles from './styles.module.scss'

export default function Dashboard() {

  return (
      <div className={styles.content}>
        <Header size="huge">Dashboard</Header>
        <img src="/images/dashboard2.jpg" className={styles.tmp_img} alt={"dashboard"}/>
      </div>
  )

}
